var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.outTime
        ? _c("div", [
            _c("i", {
              staticClass: "icon-shipinbofang",
              staticStyle: { "font-size": "80px !important" },
              on: {
                click: function ($event) {
                  return _vm.playVideo()
                },
              },
            }),
            _c("p", [_vm._v("点击播放视频")]),
          ])
        : _vm._e(),
      _vm.outTime
        ? _c("div", [
            _c("i", { staticClass: "el-icon-video-play shipin-i" }),
            _c("p"),
            _c("i", { staticClass: "el-icon-time" }, [_vm._v(" 该视频已过期")]),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.mainLoading,
              expression: "mainLoading",
            },
          ],
          attrs: {
            visible: _vm.dialogVideo,
            "append-to-body": "",
            title: "视频播放",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVideo = $event
            },
          },
        },
        [
          _vm.playerOptions.sources[0].src
            ? _c("video-player", {
                ref: "videoPlayer",
                staticClass: "video-player vjs-custom-skin",
                attrs: { options: _vm.playerOptions, playsinline: true },
                on: {
                  pause: function ($event) {
                    return _vm.onPlayerPause($event)
                  },
                  play: function ($event) {
                    return _vm.onPlayerPlay($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }